<div class="container">
  <div class="container__title">
    <h2 class="title">
      物語の主人公になれる絵本が<br />プレゼントされました！
    </h2>
  </div>
  <div class="container__subtitle">
    <h3 class="subtitle">作る絵本を選びましょう</h3>
  </div>
  <div class="container__content">
    <ng-container
      *ngIf="mediaService.isLtXl$ | async; then content; else carousel"
    ></ng-container>
    <ng-template #carousel>
      <app-carousel
        [products]="books"
        (buttonClick)="onSelect($any($event.alias))"
      ></app-carousel>
    </ng-template>
    <ng-template #content>
      <div
        class="content"
        *ngIf="mediaService.isLtLg$"
      >
        <app-product
          *ngFor="let book of books"
          [alias]="book.alias"
          [photo]="book.menuPhoto"
          [caption]="book.caption"
          [summary]="book.summary"
          [notice]="book.notice"
          buttonText="この絵本を見る"
          buttonColor="accent-2"
          (buttonClick)="onSelect(book.alias)"
        ></app-product>
      </div>
    </ng-template>
  </div>
</div>
